export default __webpack_public_path__ + "static/media/7.59aa5262.png";